/**
 * The React context behind `useAuth`.
 *
 * It lives in its own module — rather than inside `AuthContext.tsx` — so that a
 * consumer can supply a context VALUE without importing the provider. The
 * provider transitively pulls the API client, the axios instance, the query
 * persister and the emulation/demo session helpers; the test auth harness
 * (`test-utils/renderWithAuth`) needs none of that, and it is imported by nearly
 * every component test.
 *
 * Production code never imports this directly: mount `AuthProvider` and read
 * through `useAuth`, both of which live in `AuthContext.tsx`.
 */

import { createContext } from 'react';
import type { AuthContextType } from './types';

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
